import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M22 11.08V12a10 10 0 1 1-5.93-9.14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "22 4 12 14.01 9 11.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "CheckCircle";
const CheckCircle = memo(themed(Icon));
export {
  CheckCircle
};
//# sourceMappingURL=check-circle.js.map
